import { NotificationRepository } from '../repositories/NotificationRepository';
import { logger } from '@/src/core/utils';

export class RemovePushTokenUseCase {
  constructor(private notificationRepository: NotificationRepository) {}

  async execute(userId: string, token: string): Promise<void> {
    logger.debug('RemovePushToken', 'Removing token for user', { userId });
    await this.notificationRepository.removePushToken(userId, token);
    logger.debug('RemovePushToken', 'Token removed successfully');
  }
}
